export const SELECT_DOCUMENTS = 'SELECT_DOCUMENTS';